import React, { createContext, useRef, useEffect } from "react";
// import clickSound from "https://d1ccopf5cw1hft.cloudfront.net/s3data/clicksound.mp3";

const AudioContext = createContext();
export const AudioProvider = ({ children }) => {
  const audioRef = useRef(null);
  const clickSound ="https://d1ccopf5cw1hft.cloudfront.net/s3data/clicksound.mp3";

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(clickSound); // Use the imported audio file
    }
  }, []);

  const playClick = () => {
    if (audioRef.current) {
      console.log("Audio triggered");
      audioRef.current.currentTime = 0; // Reset playback to the start
      audioRef.current.play().catch((err) => {
        console.error("Playback failed:", err); // Handle potential autoplay restrictions
      });
    }
  };

  return (
    <AudioContext.Provider value={playClick}>{children}</AudioContext.Provider>
  );
};

export const useAudio = () => React.useContext(AudioContext);
